import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { Alert, Snackbar } from '@lumahealthhq/ui-core';
import SnackbarContext from './SnackbarContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ANCHOR_POSITIONS = {
  LEFT: 'left',
  BOTTOM: 'bottom',
  CENTER: 'center'
};
const AUTO_HIDE_DURATION = 4000; // 4 secs

/**
 * @ignore - internal component.
 */
export default function MessageProvider({
  children,
  onMessage
}) {
  const [snackPack, setSnackPack] = React.useState([]);
  const [isOpen, setIsOpen] = React.useState(false);
  const [messageInfo, setMessageInfo] = React.useState(undefined);
  const handleMessage = React.useCallback(({
    message,
    variant = 'info'
  }) => {
    if (onMessage) {
      onMessage({
        message,
        variant
      });
      return;
    }
    setMessageInfo({
      key: new Date().getTime(),
      message,
      variant
    });
    setIsOpen(true);
  }, [onMessage]);
  React.useEffect(() => {
    if (snackPack.length && !messageInfo) {
      // Set a new snack when we don't have an active one
      setMessageInfo(_extends({}, snackPack[0]));
      setSnackPack(prev => prev.slice(1));
      setIsOpen(true);
    } else if (snackPack.length && messageInfo && isOpen) {
      // Close an active snack when a new one is added
      setIsOpen(false);
    }
  }, [snackPack, messageInfo, isOpen]);
  const handleClose = React.useCallback((event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setIsOpen(false);
  }, []);
  const handleExited = React.useCallback(() => {
    setMessageInfo(undefined);
  }, []);
  const position = React.useMemo(() => (messageInfo == null ? void 0 : messageInfo.variant) === 'error' ? {
    horizontal: ANCHOR_POSITIONS.CENTER,
    vertical: ANCHOR_POSITIONS.BOTTOM
  } : {
    horizontal: ANCHOR_POSITIONS.LEFT,
    vertical: ANCHOR_POSITIONS.BOTTOM
  }, [messageInfo == null ? void 0 : messageInfo.variant]);
  const values = React.useMemo(() => ({
    handleMessage
  }), [handleMessage]);
  return /*#__PURE__*/_jsxs(SnackbarContext.Provider, {
    value: values,
    children: [!onMessage && /*#__PURE__*/_jsx(Snackbar, {
      open: isOpen,
      anchorOrigin: position,
      autoHideDuration: AUTO_HIDE_DURATION,
      onClose: handleClose,
      TransitionProps: {
        onExited: handleExited
      },
      children: messageInfo && /*#__PURE__*/_jsx(Alert, {
        onClose: handleClose,
        severity: messageInfo.variant,
        sx: {
          width: '100%'
        },
        children: messageInfo.message
      })
    }, messageInfo ? messageInfo.key : undefined), children]
  });
}